export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img4-5b5e6168284e201ed61189859591dd58.png";